export interface RouteInfo {
  path: string;          // Router path
  title: string;         // Display text
  icon: string;          // Optional icon class
  class: string;         // CSS classes (like "has-arrow")
  extralink: boolean;    // If true, not clickable
  submenu: RouteInfo[];  // Recursive submenu
  roles?: string[];      // Allowed roles (optional)
}

// Example ROUTES array with roles
export const ROUTES: RouteInfo[] = [{
        path: '/dashboard/tracer',
        title: 'Dashboard',
        icon: 'fas fa-home',
        class: '',
        extralink: false,
        submenu: [],
        roles: ['USR','ADMIN']
    },
    {
        path: '',
        title: 'Sociedades',
        icon: 'fas fa-dollar-sign',
        class: 'has-arrow',
        extralink: false,
        submenu: [
            {
                path: '/administracion/menu/sociedad',
                title: 'Creación de Sociedad',
                icon: 'fas fa-chart-bar',
                class: '',
                extralink: false,
                submenu: [],
                roles: ['ADMIN']
            },
            {
                path: '/administracion/actoCorporativo',
                title: 'Actos Corporativos',
                icon: 'fas fa-dollar-sign',
                class: '',
                extralink: false,
                submenu: [],
                roles: ['USR','ADMIN']
            },
            {
                path: '/administracion/documentos',
                title: 'Libros Corporativos',
                icon: 'fas fa-download',
                class: '',
                extralink: false,
                submenu: [],
                roles: ['ADMIN']
            },
            {
                path: '/administracion/sociedades',
                title: 'Editar Sociedades',
                icon: 'fas fa-building',
                class: '',
                extralink: false,
                submenu: [],
                roles: ['ADMIN']
            },
            {
                path: '/administracion/editarAccionistas',
                title: 'Editar Accionistas',
                icon: 'fas fa-user',
                class: '',
                extralink: false,
                submenu: [],
                roles: ['ADMIN']
            },
        ],
        roles: ['USR','ADMIN']
    },
    {
        path: '/administracion/mydocuments2',
        title: 'Mis Documentos',
        icon: 'fas fa-file-alt',
        class: '',
        extralink: false,
        submenu: [],
        roles: ['USR','ADMIN']
    },
    {
        path: '',
        title: 'Firma Electronica',
        icon: 'fas fa-key',
        class: 'has-arrow',
        extralink: false,
        submenu: [
            {
                path: '/administracion/signature',
                title: 'Firmar Documento',
                icon: 'fas fa-user',
                class: '',
                extralink: false,
                submenu: [],
                roles: ['ADMIN']
            },
            {
                path: '/administracion/hook-archive',
                title: 'Archivo Firma Electronica',
                icon: 'fas fa-folder',
                class: '',
                extralink: false,
                submenu: [],
                roles: ['ADMIN']
            },
        ],
        roles: ['ADMIN']
    },
    {
        path: '',
        title: 'PLD-KYC',
        icon: 'fas fa-file-alt',
        class: 'has-arrow',
        extralink: false,
        submenu: [
            {
                path: '/administracion/pldPersonFile',
                title: 'Mi Expediente PLD Beneficiarios',
                icon: 'fas fa-user',
                class: '',
                extralink: false,
                submenu: [],
                roles: ['ADMIN']
            },    
            {
                path: '/administracion/copiaCertificada',
                title: 'Documentos PLD Sociedad',
                icon: 'fas fa-user',
                class: '',
                extralink: false,
                submenu: [],
                roles: ['ADMIN']
            },
           
        ],
        roles: ['ADMIN']
    },
    {
        path: 'administracion/powers-of-attorney/',
        title: 'Poder Notarial',
        icon: 'fas fa-folder',
        class: '',
        extralink: false,
        submenu: [],
        roles: ['ADMIN']
    },
    {
        path: '',
        title: 'Configuración',
        icon: 'fas fa-cogs',
        class: 'has-arrow',
        extralink: false,
        submenu: [
            {
                path: '/administracion/configuracion',
                title: 'Email',
                icon: 'fas fa-folder',
                class: '',
                extralink: false,
                submenu: [],
                roles: ['ADMIN']
            },
            {
                path: 'administracion/configuraTipoCopia',
                title: 'Tipo Documento PLD',
                icon: 'fas fa-newspaper',
                class: '',
                extralink: false,
                submenu: [],
                roles: ['ADMIN']
            },
            {
                path: 'administracion/configuracionConsejo',
                title: 'Consejo Administracion',
                icon: 'fas fa-users',
                class: '',
                extralink: false,
                submenu: [],
                roles: ['ADMIN']
            },
            {
                path: '/administracion/configuraTipoAsamblea',
                title: 'Tipo Asambleas',
                icon: 'fas fa-newspaper',
                class: '',
                extralink: false,
                submenu: [],
                roles: ['ADMIN']
            },
            {
                path: '/administracion/videosConfiguracion',
                title: 'Manuales',
                icon: 'fas fa-film',
                class: '',
                extralink: false,
                submenu: [],
                roles: ['ADMIN']
            },
            {
                path: '/administracion/configuracionNotario',
                title: 'Notarios',
                icon: 'fas fa-pencil-alt',
                class: '',
                extralink: false,
                submenu: [],
                roles: ['ADMIN']
            },
            {
                path: '/administracion/configuracionPoderes',
                title: 'Catalogo Poderes',
                icon: 'fas fa-pencil-alt',
                class: '',
                extralink: false,
                submenu: [],
                roles: ['ADMIN']
            },
        ],
        roles: ['ADMIN']
    },
 

 
];
